<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("advancebookingreport") }}</div>
      <div class="mt-3 mb-0">
        <div class="row">
          <!-- SELECT DROPDOWN -->

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="getAdvanceBookingReportSelectedCinema ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :text="getAdvanceBookingReportSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    onAdvanceBookingReportDropDownHandler({
                      event: $event,
                      name: 'isCinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex,
                    });
                    searchCinema = '';
                    onSearchCinema();
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getAdvanceBookingReportFromDate"
                  @click="
                    onAdvanceBookingReportDropDownHandler({
                      event: null,
                      name: 'fromDate',
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onAdvanceBookingReportDropDownHandler({
                      event: $event,
                      name: 'fromDate',
                    })
                  "
                  :value="getAdvanceBookingReportFromDate"
                  typeable
                ></Datepicker>
                <label
                  :class="getAdvanceBookingReportFromDate ? 'active' : ''"
                  >{{ $t("startdate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <button
              @click="onFetchAdvanceBookingReport"
              class="btn-blue-lg w-100"
            >
              {{ $tc("getReport") }}
            </button>
          </div>

          <div
            v-if="
              getAdvanceBookingReportData &&
                getAdvanceBookingReportData.length > 0
            "
            class="col-lg-4 col-xl-3 align-self-center mb-4 d-flex justify-content-end align-items-center"
          >
            <div>{{ $t("download") }} as:</div>
            <a
              v-if="getAdvanceBookingReportsPDFFileName"
              :href="BASE_URL + getAdvanceBookingReportsPDFFileName"
              target="_blank"
              download
              title="Download as PDF"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>

            <a
              v-if="getAdvanceBookingReportsExcelFileName"
              :href="BASE_URL + getAdvanceBookingReportsExcelFileName"
              target="_blank"
              title="Download as Excel"
              download
              class="d-none"
            >
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </a>
            <img
              @click="ExportExcel('xlsx')"
              src="@/assets/img/icons/excel.svg"
              height="25"
              width="25"
              class="mx-2"
            />
          </div>
          <div class="mx-2"
            ><b-dropdown
              name="listview"
              id="listview"
              variant="outline-blue"
              class=""
            >
              <template v-slot:button-content>
                {{ $tc("viewing") }}&nbsp;
                <strong>{{ updateSelectedValue }}</strong>
                &nbsp;Of&nbsp;
                <strong>{{ getAdvanceBookingReportTotalRows }}</strong>
              </template>
              <b-dropdown-item
                v-for="(list, listIndex) in viewingnumbers"
                :key="listIndex"
                @click="onDropDownChangeValue(list.name)"
                >{{ list.name }}</b-dropdown-item
              >
            </b-dropdown></div
          >
        </div>
      </div>

      <table
        class="d-none"
        border="1"
        ref="exportable_table"
        style="width: auto !important; white-space: nowrap;"
      >
        <thead class>
          <tr class="bg-lightgrey">
            <th>{{ $t("voucher") }} {{ $t("no") }}</th>
            <th>{{ $tc("booking", 1) }} {{ $tc("date", 1) }}</th>
            <th>{{ $tc("film", 1) }} {{ $t("name") }}</th>
            <th>{{ $t("show") }} {{ $tc("date", 1) }}</th>
            <th>{{ $t("show") }} {{ $tc("time", 1) }}</th>
            <th>{{ $tc("screen", 1) }} {{ $tc("name", 1) }}</th>
            <th>{{ $tc("seat", 1) }} {{ $tc("number", 1) }}</th>
            <th>{{ $t("net") }} {{ $tc("rate") }}</th>
            <th>{{ $t("net") }} {{ $tc("sale") }} {{ $tc("price") }}</th>
            <th>{{ $t("discount") }}</th>
            <th>P.{{ $t("type") }}</th>
            <th>{{ $t("mobileNo") }}</th>
            <th colspan="2">{{ $t("transaction") }} {{ $t("number") }}</th>
          </tr>
        </thead>
        <tbody v-if="getAdvanceBookingReportData.length > 0" class="sph-report">
          <tr
            v-for="(transaction,
            transactionIndex) in getAdvanceBookingReportData"
            :key="transactionIndex"
          >
            <td>{{ transaction.offer_name || "-" }}</td>
            <td>{{ transaction.t_booking_date_time | dateparse }}</td>
            <td class="text-left">{{ transaction.film_name }}</td>
            <td>{{ transaction.t_show_date | dateparse }}</td>
            <td class="text-right">{{ transaction.t_show_time }}</td>
            <td class="text-left">{{ transaction.screen_name }}</td>
            <td class="text-right">{{ transaction.seats }}</td>
            <td class="text-right">{{
              currFormat(transaction.t_net_amount)
            }}</td>
            <td class="text-right">{{
              currFormat(transaction.total_amount)
            }}</td>
            <td class="text-right">{{ currFormat(transaction.discount) }}</td>
            <td>{{ transaction.p_type || "-" }}</td>
            <td class="text-center">{{
              transaction.customer_mobile || "-"
            }}</td>
            <td colspan="2" class="text-right">{{
              transaction.sb_booking_code
            }}</td>
          </tr>
        </tbody>
        <tbody v-else class="sph-report">
          <td colspan="15">
            <!-- {{ $tc("NoRecords") }} -->
            <NoRecords />
          </td>
        </tbody>
      </table>

      <div class="swc-report" style="overflow-x: scroll;">
        <table
          class="swc-report-table"
          border="1"
          style="width: auto !important; white-space: nowrap;"
        >
          <thead class>
            <tr class="bg-lightgrey">
              <th>{{ $t("voucher") }} {{ $t("no") }}</th>
              <th>{{ $tc("booking", 1) }} {{ $tc("date", 1) }}</th>
              <th>{{ $tc("film", 1) }} {{ $t("name") }}</th>
              <th>{{ $t("show") }} {{ $tc("date", 1) }}</th>
              <th>{{ $t("show") }} {{ $tc("time", 1) }}</th>
              <th>{{ $tc("screen", 1) }} {{ $tc("name", 1) }}</th>
              <th>{{ $tc("seat", 1) }} {{ $tc("number", 1) }}</th>
              <th>{{ $t("net") }} {{ $tc("rate") }}</th>
              <th>{{ $t("net") }} {{ $tc("sale") }} {{ $tc("price") }}</th>
              <th>{{ $t("discount") }}</th>
              <th>P.{{ $t("type") }}</th>
              <th>{{ $t("mobileNo") }}</th>
              <th colspan="2">{{ $t("transaction") }} {{ $t("number") }}</th>
              <th class="d-none">{{ $t("HHId") }}</th>
            </tr>
          </thead>
          <tbody
            v-if="getAdvanceBookingReportData.length > 0"
            class="sph-report"
          >
            <tr
              v-for="(transaction,
              transactionIndex) in getAdvanceBookingReportData"
              :key="transactionIndex"
            >
              <td>{{ transaction.offer_name || "-" }}</td>
              <td>{{ transaction.t_booking_date_time | dateparse }}</td>
              <td class="text-left">{{ transaction.film_name }}</td>
              <td>{{ transaction.t_show_date | dateparse }}</td>
              <td class="text-right">{{ transaction.t_show_time }}</td>
              <td class="text-left">{{ transaction.screen_name }}</td>
              <td class="text-right">{{ transaction.seats }}</td>
              <td class="text-right">{{
                currFormat(transaction.t_net_amount)
              }}</td>
              <td class="text-right">{{
                currFormat(transaction.total_amount)
              }}</td>
              <td class="text-right">{{ currFormat(transaction.discount) }}</td>
              <td>{{ transaction.p_type || "-" }}</td>
              <td class="text-right">{{
                transaction.sb_mobile_number || "-"
              }}</td>
              <td colspan="2" class="text-right">{{
                transaction.sb_booking_code
              }}</td>
              <td class="d-none">{{ transaction.HHHId || "-" }}</td>
            </tr>
          </tbody>
          <tbody v-else class="sph-report">
            <td colspan="15">
              <!-- {{ $tc("NoRecords") }} -->
              <NoRecords />
            </td>
          </tbody>
        </table>
      </div>
      <b-pagination
        v-if="getAdvanceBookingReportData.length > 0"
        v-model="getAdvanceBookingReportcurrentPage"
        :total-rows="getAdvanceBookingReportTotalRows"
        @change="onChangePagination($event)"
        :per-page="updatePerPage"
        aria-controls="my-table"
        class="my-3"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import * as XLSX from "xlsx";
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: { DatePicker, NoRecords },
  data() {
    return {
      CinemasCopy: [],
      searchCinema: "",
      Cinemas: [],
      isRoleID: true,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
    };
  },
  computed: {
    ...mapGetters([
      "getCinemasList",
      "getAdvanceBookingReportSelectedCinema",
      "getAdvanceBookingReportFromDate",
      "getAdvanceBookingReportData",
      "getAdvanceBookingReportLimit",
      "getAdvanceBookingReportcurrentPage",
      "getAdvanceBookingReportTotalRows",
      "getAdvanceBookingReportperPage",
      "getAdvanceBookingReportselectedValue",
      // EXCEL
      "getAdvanceBookingReportsExcelFileName",
      // PDF
      "getAdvanceBookingReportsPDFFileName",
    ]),
    updateLimit() {
      return this.$store.getters.getAdvanceBookingReportLimit;
    },
    updatePerPage: {
      get() {
        return this.$store.getters.getAdvanceBookingReportperPage;
      },
      set(value) {
        return this.$store.dispatch("updatePerPage", value);
      },
    },
    updateSelectedValue: {
      get() {
        return this.$store.getters.getAdvanceBookingReportselectedValue;
      },
      set(value) {
        return this.$store.dispatch("updateSelectedValue", value);
      },
    },
  },

  mounted() {
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getviewingnumber();
    // if (CinemaObj) {
    //   this.onAdvanceBookingReportDropDownHandler({
    //     event: null,
    //     name: "isCinema",
    //     selectedItem: CinemaObj
    //   });
    // }

    // this.fetchCinemasList({ cinemaId });
  },

  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onAdvanceBookingReportDropDownHandler({
    //       event: null,
    //       name: "isCinema",
    //       selectedItem: CinemaObj
    //     });
    //   }
    // }
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.onAdvanceBookingReportDropDownHandler({
          name: "limit",
          limit: this.getAdvanceBookingReportTotalRows,
        });
        // this.perPage = this.getAdvanceBookingReportLimit;
        this.updatePerPage = this.getAdvanceBookingReportLimit;
        this.updateSelectedValue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.updateSelectedValue = event;
        this.updatePerPage = event;
        // this.perPage = event;
        this.onAdvanceBookingReportDropDownHandler({
          name: "limit",
          limit: event,
        });
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    onChangePagination: function(event) {
      console.log(event);
      if (event === undefined) {
        this.onAdvanceBookingReportDropDownHandler({
          name: "currentPage",
          currentPage: 1,
        });
        // this.currentPage = 1;
        this.onFetchAdvanceBookingReport();
      } else {
        this.onAdvanceBookingReportDropDownHandler({
          name: "currentPage",
          currentPage: event,
        });
        // this.currentPage = event;
        this.onFetchAdvanceBookingReport();
      }
    },
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, {
        sheet: "Advance Booking Report",
      });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : // XLSX.insert_image('B12', 'python.png', {'x_offset': 15, 'y_offset': 10})
          XLSX.writeFile(wb, fn || "AdvanceBookingReport." + (type || "xlsx"));
    },
    onSelectCinema(cinema) {
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      //  let payload = null
      //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            // this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // let cinema = {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // };

                // this.onSelectCinema(null,cinema);
                this.onAdvanceBookingReportDropDownHandler({
                  name: "isCinema",
                  selectedItem: {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id,
                  },
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    ...mapActions([
      //
      "fetchCinemasList",
      "onAdvanceBookingReportDropDownHandler",
      "onFetchAdvanceBookingReport",
    ]),
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/advanceBookingReport.vue